// extracted by mini-css-extract-plugin
module.exports = {"sectionContent":"WhyUs-module--sectionContent--2vRgR","heroPresentation":"WhyUs-module--heroPresentation--22i6Z","whyUsLogo":"WhyUs-module--whyUsLogo--2ZAo-"};